import { Trans } from 'react-i18next';
import * as Yup from 'yup';

import { MAX_FEATURE_NAME_LENGTH, MIN_LENGTH } from '@hero/constants';

export const collectionNameFormData = [
  {
    name: 'collectionName',
    label: <Trans i18nKey="collectionName" />,
    type: 'text',
    maxLength: MAX_FEATURE_NAME_LENGTH
  }
];

export const collectionNameFormValidationSchema = Yup.object({
  collectionName: Yup.string().min(MIN_LENGTH).max(MAX_FEATURE_NAME_LENGTH).required()
});
